import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Trademark Texticon | Your Data Security & Privacy</title>
        <meta name="description" content="Read Trademark Texticon's privacy policy. Learn how we collect, use, and protect your personal information during trademark registration services. Your privacy is our priority." />
        <meta name="keywords" content="privacy policy, data protection, trademark services privacy, personal information security, GDPR compliance" />
      </Helmet>
      
      <div className="legal-page">
        <div className="legal-container">
          <h1>Privacy Policy</h1>
          <p className="legal-updated">Last Updated: December 2024</p>
          
          <section>
            <h2>1. Information We Collect</h2>
            <p>We collect information you provide directly to us when using our trademark registration services, including your name, email address, phone number, business information, and trademark details.</p>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to provide, maintain, and improve our trademark registration services, communicate with you, and comply with legal obligations.</p>
          </section>

          <section>
            <h2>3. Information Sharing</h2>
            <p>We do not sell your personal information. We may share your information with service providers, legal authorities when required, and as necessary to provide our services.</p>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
          </section>

          <section>
            <h2>5. Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal information. Contact us at info@trademarktexticon.com to exercise these rights.</p>
          </section>

          <section>
            <h2>6. Contact Us</h2>
            <p>For questions about this Privacy Policy, please contact us at info@trademarktexticon.com or call +1 (123) 123-4567.</p>
          </section>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
